export default "__VITE_PUBLIC_ASSET__616241ee__"